import { sendAPIRequest } from "shared/utils/requests";

import React, { Component } from "react";
import _ from "lodash";
import { Radio, RadioGroup } from "@blueprintjs/core";
import QuizQuestion from './quizQuestion'
import Button from "../base-components/button"
import classNames from "classnames";

class Privacy extends Component {
  constructor(props) {
    super(props);

    const { privacyQuiz } = this.props;
    this.state = {
      privacyQuizForm: privacyQuiz.map((item) => {
        item = Object.assign({}, item);
        item.selectedAnswerIndex = null;
        return item;
      }),
      grades: [],
      failed: false,
    };
  }

  renderDivider(text) {
    return (
      <div className="onboarding-privacy-divider">
        <div className="onboarding-privacy-divider-accent" />
        {text}
        <div className="onboarding-privacy-divider-divider" />
      </div>
    );
  }

  renderPolicyItem(title, subtitle, key) {
    return (
      <div className="onboarding-privacy-item" key={key}>
        <div className="onboarding-privacy-item-title">
          {title}
        </div>
        <div className="onboarding-privacy-item-subtitle">
          {subtitle}
        </div>
      </div>
    );
  }

  renderHeader() {
    return this.renderPolicyItem(
      "Review Our Privacy Policy & Take the Quiz",
      "Read the privacy policies below and then take the quiz. Once you pass the quiz, you can then proceed to the next step",
      "header"
    );
  }

  renderPolicy() {
    const policies = [
      {
        title: "Don’t share or post information about QA World, any of our customers products, or any of our customer’s conversations",
        subtitle: "You should not share the names of our customers, account information, details about our technology, details about the names of your peers and managers at QA World, or any other information.",
      },
      {
        title: "Don’t download audio",
        subtitle: "Do not use any third party tool to download call audios from QA World.",
      },
      {
        title: "Don’t transcribe QA World audio outside of the platform",
        subtitle: "Using other programs to edit transcription, such as Microsoft Word, is not okay. All typing that you do with respect to the audio transcriptions should be within the QA World platform. This protects our use and customer data",
      },
      {
        title: "Moving Personal Identifiable Information (PII) from within calls to outside platform is a felony",
        subtitle: "You should never copy a transcript onto your computer. This includes copying it into Microsoft Word to edit. Personal Identifiable Information includes names, addresses, phone numbers, or any other relevant information using the name of an individual.",
      },
      {
        title: "Don’t take screenshots of the platform unless the SCC asks you to",
        subtitle: "Screenshots of QA World, the queue, your profile, a transcript you worked on, etc. All are prohibited. The only exception is if the SCC asks you to in order to help fix a problem. In that case, you must delete the screenshot immediately from your computer after sending it to the SCC. Only send screenshots in a direct message, not on the #helpdesk channel.",
      },
      {
        title: "Don’t contact QA World customers, their employees, or their customers",
        subtitle: "You should never try to make contact with a QA World customer, their employees, or their customers.",
      },
      {
        title: "If you put your job title on Facebook, LinkedIn, etc, it should read “Transcriber at QA World” or “Analyst at QA World”",
        subtitle: "It should not reference any related organization. Please only use the name QA World.",
      },
    ];
    
    return policies.map((policy, idx) => {
      return this.renderPolicyItem(policy.title, policy.subtitle, idx);
    });
  }

  renderQuizItem(item, wrongIndex, itemIndex) {
    return (
      <QuizQuestion index={itemIndex + 1} question={item.question} answers={item.answers} wrongIndex={wrongIndex} key={itemIndex} setAnswerIndex={answer => {
        const newState = JSON.parse(JSON.stringify(this.state.privacyQuizForm))
        newState[itemIndex].selectedAnswerIndex = answer;
        this.setState({ privacyQuizForm: newState });
      }} />
    );
  }

  async submitQuiz() {
    const {
      updateOnboardingStep,
    } = this.props;

    const {
      privacyQuizForm,
    } = this.state;

    const response = await sendAPIRequest(`/onboarding/submit_privacy_quiz`, "POST", { answers: privacyQuizForm.map(item => item.selectedAnswerIndex) });
    if (response.data.status == 'success') {
      updateOnboardingStep(response.data.onboardingStep);
    } else if (response.data.status == 'failure') {
      this.setState({ grades: response.data.grades, failure: true });
    } else {
      throw new Error("invalid status for privacy quiz submission: " + response.data.status)
    }
  }

  renderQuiz() {
    const {
      privacyQuizForm,
      grades,
    } = this.state;

    return (
      <form className="onboarding-privacy-quiz">
        {privacyQuizForm.map((item, i) => {
          return this.renderQuizItem(item, grades[i] == null || grades[i].correct ? -1 : grades[i].response, i)
        })}
      </form>
    );
  }

  render() {

    const {
      failure,
    } = this.state;

    const messageClasses = classNames({
      'onboarding-error-label': true,
      'onboarding-error-label-hidden': !failure,
    });
    return (
      <div className="onboarding-privacy-container">
        {this.renderHeader()}

        {this.renderDivider('PRIVACY POLICIES')}

        {this.renderPolicy()}

        {this.renderDivider('QUIZ')}

        {this.renderQuiz()}

        <div className={messageClasses}>
          You didn{"'"}t pass the privacy policies quiz. Please re-read the privacy policies, update <br />
          your incorrect answers, and re-submit. You can retake the quiz until you pass.
        </div>

        <div className="onboarding-divider"/>
        <div className="onboarding-submission">
          <Button className="onboarding-submission-button" onClick={() => this.submitQuiz()} text="Submit Answers & Continue" />
        </div>
      </div>
    );
  }

}

export default Privacy;
